"use client";
import "./index.css";

export default function TableOfContents(props) {
  const { onItemClick } = props;

  const handleItemClick = (item) => {
    onItemClick(item);
  };

  return (
    <ul id="TableOfContent" className="Table-of-Content">
      {props.titleNames?.map((item, i) => {
        return (
          <li
            style={{ cursor: "pointer" }}
            key={item + i}
            id={
              props.tableOfContent[i] === props.activeItem ? "activeItem" : ""
            }
            className="Table-Of-ContentItem"
            onClick={() => handleItemClick(props.tableOfContent[i])}
          >
            {item.toLowerCase() === "copd"
              ? "AICOPD"
              : item.toLowerCase() === "ckd"
              ? "AICKD"
              : item.toLowerCase() === "mirai"
              ? "MIRAI Breast Cancer"
              : item.toLowerCase() === "sybil"
              ? "Sybil Chest CT"
              : item.toLowerCase() === "ecg"
              ? "ECG Reporting"
              : item.toLowerCase() === "radilogy"
              ? "Radiology Reporting"
              : item.toLowerCase() === "vtb"
              ? "Virtual Tumor Board"
              : item.toLowerCase() === "genai"
              ? "Discharge Summary - Gen AI"
              : item.toLowerCase() === "pii"
              ? "PII Anonymizer"
              : item.toLowerCase() === "cer"
              ? "Clinical Entity Recognition"
              : item.toLowerCase() === "ncp"
              ? "Nursing Care Plan - Gen AI"
              : item}
          </li>
        );
      })}
    </ul>
  );
}
